<template>
  <pagefra>
    <div class="servicePackage"></div>
    <ServicePackage :visible="dialogVisible" @close="closeTab" />
  </pagefra>
</template>

<script>
import ServicePackage from "@/components/servicePackage.vue";

export default {
  name: "servicePackage",
  components: {
    ServicePackage,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() {
    this.dialogVisible = true;
  },
  methods: {
    closeTab() {
      this.dialogVisible = false;
      const tabs = this.$store.state.routerTabList;
      const idx = tabs.findIndex((v) => v.path === this.$route.path);
      if (idx > -1) {
        tabs.splice(idx, 1);
        this.$store.commit("setRouterTabList", tabs);
        if (tabs.length) {
          const next = tabs[Math.min(idx, tabs.length - 1)];
          this.$router.push(next.path);
        }
      }
    },
  },
};
</script>
